module.exports = __webpack_public_path__ + "static/media/ico-exito.1bf9c25d.svg";